export default __webpack_public_path__ + "static/media/Logo-cap.7fcffdcd.png";